addEventListeners();
function addEventListeners() {
  $a(".menu__first-level__item").forEach((element) => {
    if (window.innerWidth < 1024) {
      element.addEventListener("click", (e) => expandSubMenuMobile(e));
    } else {
      element.addEventListener("mouseenter", (e) => expandSubMenuDesktop(e));
    }
  });
  $a(".menu__item__back").forEach((element) => {
    element.addEventListener("click", (e) => collapseSumMenuMobile(e));
  });
  $(".menu__close").addEventListener("click", (e) => {
    closeMenu();
  });
  $(".header__icon  .icon-close").addEventListener("click", (e) => {
    closeMenu();
  });
  $(".menu__shop__trigger").addEventListener("click", (e) => {
    e.preventDefault();
    let menuContainer = $(".menu__container");
    gsap.to(menuContainer, { left: "0%", duration: 0.05 });
  });
  $(".header__menu-item__shop").addEventListener("click", (e) => {
    e.preventDefault();
    let menuContainer = $(".menu__container");
    gsap.to(menuContainer, { left: "0%", duration: 0.05 });
  });
  $(".menu__desktop__close").addEventListener("click", (e) => {
    closeMenu();
  });
}

function closeMenu() {
  let menuContainer = $(".menu__container");
  gsap.to(menuContainer, { left: "100%", duration: 0.05 });
}

function expandSubMenuMobile(e) {
  if (e.target.getAttribute("data-target")) {
    let lastLevelList = $(".menu__last-level");
    let listToShow = $(`#${e.target.getAttribute("data-target")}`);

    listToShow.style.zIndex = 10;
    gsap.fromTo(lastLevelList, { left: "100%" }, { left: "0%", duration: 0.4 });
  }
}
function collapseSumMenuMobile(e) {
  if (e.target.getAttribute("data-target")) {
    let lastLevelList = $(".menu__last-level");
    let listToHide = $(`#${e.target.getAttribute("data-target")}`);

    listToHide.style.zIndex = 0;
    gsap.to(lastLevelList, { left: "100%", duration: 0.4 });
  }
}
function expandSubMenuDesktop(e) {
  if (e.target.getAttribute("data-target")) {
    let listToShow = $(`#${e.target.getAttribute("data-target")}`);

    $a(".menu__last-level__list").forEach((element, index) => {
      element.style.zIndex = 0;
      element.style.display = "none";
      if (element.getAttribute("id") === e.target.getAttribute("data-target")) {
        $a(".menu__picture div img").forEach((imgElement, imgIndex) => {
          if (imgIndex == index) {
            imgElement.style.display = "block";
          } else {
            imgElement.style.display = "none";
          }
        });
      }
    });
    listToShow.style.zIndex = 1;
    listToShow.style.display = "block";
  }
}
function collapseSumMenuDesktop(e) {
  //   alert(`Fired : ${e.target.getAttribute("data-target")}`);
}
